import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import 'vuetify/src/stylus/app.styl';
import appconfig from '../config/shared';

Vue.use(Vuetify);

export default new Vuetify(appconfig.vuetify);
